import { selfServiceInstance } from "../axios/selfServiceInstance";
import {
  GENERATE_INVOICE_PAYLOAD,
  REPORT_PARAMS,
  TSearchParams,
  VERIFY_FUND_WALLET_PAYLOAD,
  VERIFY_PAYMENT_PAYLOAD,
} from "../types/buypower.type";

export const buyPowerSummary = async (payload: { amount: number; meterNumber: string }) => {
  const response = await selfServiceInstance.post("/self/buy-power-summary", payload);
  return response;
};

export const downloadInvoice = async (invoiceNumber: string) => {
  const response = await selfServiceInstance.get(`${"/self/download-invoice"}`, {
    params: { InvoiceNumber: invoiceNumber },
    responseType: "blob",
  });
  return response;
};

export const generateInvoice = async (payload:  GENERATE_INVOICE_PAYLOAD) => {
  const response = await selfServiceInstance.post("/self/generate-invoice", payload);
  return response;
};

export const generateWalletTokenSelfService = async (payload: any) => {
  const response = await selfServiceInstance.post("/self/generate-wallet-token", payload);
  return response;
};

export const downloadReceipt = async (payload: { invoiceNumber?: string; receiptNumber?: string }) => {
  const response = await selfServiceInstance.get("/self/get-receipt", {
    params: { invoiceNumber: payload.invoiceNumber, receiptNumber: payload.receiptNumber },
    responseType: "blob",
  });
  return response;
};

export const verifyAndGenerateToken = async (payload: VERIFY_PAYMENT_PAYLOAD) => {
  const response = await selfServiceInstance.post("/self/generate-token", payload);
  return response;
};

export const verifyAndFundWallet = async (payload: VERIFY_FUND_WALLET_PAYLOAD) => {
  const response = await selfServiceInstance.post("/self-service-admin/wallet-funding", payload);
  return response;
};

export const getVendingHistory = async (payload: TSearchParams<REPORT_PARAMS>) => {
  return await selfServiceInstance.post("/self-service-admin/vending-history-operator", payload);
};

// Get wallet funding history
export const getWalletHistory = async (payload: TSearchParams<REPORT_PARAMS>) => {
  return await selfServiceInstance.post("/self-service-admin/wallet-funding-report", payload);
};

export const getWalletBalance = async () => {
  const response = await selfServiceInstance.get("/self-service-admin/get-wallet-balance");
  return response;
};

export const getReportSummary = async () => {
  const response = await selfServiceInstance.get("/self-service-admin/get-transaction-summary");
  return response;
}

export  const getTransactionId =  async (payload: { invoiceNumber: string , transactionId: string}) => {
    const response = await selfServiceInstance.get('/self/get-transactionId', {
      params: {invoiceNumber: payload.invoiceNumber , transactionId: payload.transactionId },
    });
    return response;
  }
